<template>
    <div>

        <config-main-title>
            Região de Coleta Domiciliar
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <importacao service="regiao_cds" @refresh="load()" />
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"  @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Região
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma região identificada.'" 
                icon="fa-solid fa-location-dot"
                :action="'Incluir Reigão'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" :class="dado.fl_ativo ? '' : 'list-group-item-secondary'" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>

                        <div v-else-if="dado.js_classes">
                            <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in dado.js_classes" :key="icx">
                                <span class="badge badge-success ml-1">{{ classe }}</span>
                            </a>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_regiao_cd ) ? '' : 'Nova' }}
                            Região
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_regiao_cd">
                                #{{ item.id_regiao_cd }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    placeholder="Informe o nome da região..."
                                    label="Nome"
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Taxa de Cobrança"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    :optionsParm="{ ativos: true }"
                                    optionsData="id_taxa"
                                    service="taxas.index"
                                    :optionsSync="true"
                                    v-model="item.id_taxa" />
                            </div>
                        </div>

                        <div class="mt-3">
                            <multiselect
                                v-model="item.js_classes"
                                :options="options_classes"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                                placeholder="Selecione uma classificação..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhuma classificação selecionada.
                                </template>
                            </multiselect>
                        </div>

                        <div class="mt-3" v-if="item.locais && item.locais.length">
                            <az-sub-title title="Locais"></az-sub-title>
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between" v-for="(local, iux) in item.locais" :key="iux">
                                    <div>
                                        {{ local.local.st_local }}
                                    </div>
                                    <div>
                                        <span class="badge badge-light ml-3" v-if="local.local.centro_custo.unidade_operacao.st_sigla">{{ local.local.centro_custo.unidade_operacao.st_sigla }}</span>
                                        <span v-else>{{ local.local.centro_custo.unidade_operacao.st_nome }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="regiaoCd" :id="item.id_regiao_cd" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_regiao_cd ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Importacao from '../shared/Importacao.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            status_para_incluir: "", 
            fila_proced: false, 
            options_classes: [], 
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        Importacao,
        Multiselect, 
        AzSubTitle, 
    },

    computed: { 
        lista: function () { 
            let reg = this.$util.getregex(this.search);

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },
    },

    methods: { 
        filtrar(classe) { 
            if ( this.search == '"' + classe + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + classe + '"';
            }
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_regiao_cd: null,
                fl_ativo: true,
                st_nome: "", 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'regiao_cds',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.item = null;
            this.validate = false;

            this.$nextTick(() => { 

                if ( item.id_regiao_cd ) { 

                    this.$util.loadItem(this, { 
                        service: 'regiao_cds',
                        func: 'show',
                        parms: { 
                            id: item.id_regiao_cd,
                            cadastro: true, 
                        }
                    })
                    .then(res => { 
                        this.item = res;
                        $('#edicaoModal').modal('show');
                    });

                } else { 

                    this.item = _.cloneDeep (item);
                    $('#edicaoModal').modal('show');

                }

            });

        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'regiao_cds',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'regiao_cds',
                dados: item,
            });

        },
    },

    mounted () { 
        this.$util.loadItem(this, { 
            service: 'regiao_cds',
            func: 'tags',
        })
        .then(res => { 
            this.options_classes = res;
        });

        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Região", path: "/config/regiao" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
